import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';

/**
 * Service to determine if mock API mode should be enabled.
 * This service checks both URL query parameters and environment configuration
 * to decide whether to use mock API responses instead of real API calls.
 */
@Injectable({
    providedIn: 'root',
})
export class WalletPinMockConfigService {
    private readonly activatedRoute = inject(ActivatedRoute);

    /**
     * Determines if mock API mode should be enabled.
     * Checks both URL query parameter ?mock=true and environment.use_mock_repository
     * @returns boolean - true if mocking is allowed, false otherwise.
     */
    isMockApiMode(): boolean {
        const queryParams = this.activatedRoute.snapshot.queryParams;
        const useMockParam = queryParams && queryParams['mock'] === 'true';

        return useMockParam || environment.use_mock_repository;
    }
}
